const FORMULA_PREFIX = /^[=+\-@\t\r\n]/;

/** Neutralize formula prefixes and quote cells Excel would split. */
export function csvCell(value: string): string {
  const safe = FORMULA_PREFIX.test(value) ? `'${value}` : value;
  if (/[",\n\r]/.test(safe)) {
    return `"${safe.replace(/"/g, '""')}"`;
  }
  return safe;
}

export function csvReasonList(
  reasons: ReadonlyArray<{ column: string; value: string }>,
): string {
  return reasons.map((reason) => `${reason.column}=${reason.value}`).join('; ');
}
